/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-10-01 17:31:50
 *
 *******************************************************/
//@flow

import React from 'react';
import { InlineError } from '@shopify/polaris';
// import { RenderLabelTooltip } from './render-label-tooltip';
import { RenderTooltip } from '../render-tooltip';

export const RenderToggleSwitch = (field: Object) => {
  return (
    <div className="BC-Toggle-Switch">
      <label className="BC-Checkbox-Status">
        <input
          id={field.input.name}
          type="checkbox"
          disabled={field.disabled}
          checked={field.input.value ? true : false}
          onChange={field.input.onChange}
          {...field.anotherProps}
        />
        <span style={{ cursor: field.disabled ? 'default' : 'pointer' }} />
      </label>

      {/* Render label */}
      <div style={{ width: 'fit-content' }}>
        <div className="Polaris-Labelled__LabelWrapper">
          <div className="Polaris-Label">
            <label
              style={{ display: 'inline', color: field.disabled ? '#8C9196' : '' }}
              className={`Polaris-Label__Text ${field.disabled ? 'disabled' : ''}`}>
              {field.label}
            </label>
          </div>
          {/* Render icon tooltip */}
          {field.tooltip && (
            <div>
              <RenderTooltip content={field.tooltip} icon={true} disabled={field.disabled} />
            </div>
          )}
        </div>
        {field.helperText && (
          <div className="BC-Toggle-HelperText" style={{ color: field.disabled ? '#8C9196' : '' }}>
            {field.helperText}
          </div>
        )}
      </div>
      {field.meta.error ? <InlineError message={field.meta.error} /> : ''}
    </div>
  );
};
